export default __webpack_public_path__ + "static/media/logo192.fd3f2f78.png";